import { Row,  Button } from 'react-bootstrap'; // Importing Row component from react-bootstrap
import { downloadPdf } from '../PdfFunctions.js';
import Col from './Col2.js';

const DownloadButton = ({ state, pdfBlob }) => {

    return (
        <Row className="downloadButton">
        <Col className="col2-12">
            
          {state.formState.saveCopy && (
            <Button onClick = {()=>
              downloadPdf(pdfBlob, state.formState.formName)  
            } 
              variant = "primary"               
              className = "ml-2">
              Access completed form (PDF)           
            </Button>           
          )}

        </Col>
      </Row>
    );
};
export default DownloadButton;